
require("babel-polyfill");
(function () {
    const angular = require('angular');
    const conf = require('./config');
    const initInjector = angular.injector(["ng"]);
    const $http = initInjector.get("$http");

    const core = angular.module('boot', [
        require('angular-ui-router'),
        require('../commons/create-ng-module')(angular, conf).name
    ]).config(function ($stateProvider, $urlRouterProvider, $httpProvider) {

        $urlRouterProvider.otherwise('/intro');

    }).run(function ($rootScope, $state, engine,gamelog) {
        engine.init();
        gamelog.reset();
        $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams, options) => {
            console.log(toState, toParams);
        });
    });

    function bootstrapApplication(data) {

        core.constant("data", data);

        angular.element(document).ready(function () {
            angular.bootstrap(document.body, ['boot']);
        });
    }



    $http.get('assets/data.json').then(
        (response) => {
            bootstrapApplication(response.data);
        }
    );

})();